import React, { useState } from 'react';
import ScrollToTopButton from '../pages/ScrollToTopButton';
import UnderlineWithIcon from '../components/UnderlineWithIcon';
const TVET = () => {
  const [activeProgram, setActiveProgram] = useState(null);

  const toggleProgram = (program) => {
    setActiveProgram(activeProgram === program ? null : program);
  };

  const programs = [
    {
      title: 'Accounting & Finance Level II - IV',
      campuses: ['Megenagna Campus', 'Misrak Campus', 'Meskel Campus', 'Mekanissa Campus', 'Mekelle Campus'],
    },
    {
      title: 'Marketing & Sales Management Level II – IV',
      campuses: ['Megenagna Campus', 'Meskel Campus', 'Misrak Campus', 'Mekanissa Campus', 'Mekelle Campus'],
    },
    {
      title: 'Secretarial & Office Administration',
      campuses: ['Misrak Campus', 'Meskel Campus', 'Mekelle Campus'],
    },
    {
      title: 'Human Resource Management Level II - IV',
      campuses: ['Misrak Campus', 'Meskel Campus'],
    },
    {
      title: 'Hardware & Network Servicing Level I - IV',
      campuses: ['Megenagna Campus', 'Misrak Campus', 'Meskel Campus', 'Mekelle Campus'],
    },
    {
      title: 'Web Development & Database Administration Level I - IV',
      campuses: ['Misrak Campus', 'Meskel Campus', 'Mekelle Campus'],
    },
    {
      title: 'Food & Beverage Service Level I - IV',
      campuses: ['Mekelle Campus'],
    },
    {
      title: 'Information Technology Level I – IV',
      campuses: ['Kality Campus', 'Bisheftu Campus'],
    },
    {
      title: 'Tour Operation Level II – IV',
      campuses: ['Mekelle Campus'],
    },
    {
      title: 'Tour Guiding Level II – IV',
      campuses: ['Mekelle Campus'],
    },
  ];

  return (
    <div>
      <div className='tvet'>
        <div className="sidebar-page-container">
          <div className="auto-container">
            <div className="row">
              <div className="content-side col-xl-9 col-lg-8 order-lg-2">
                <div className="services-single">
                  <div className="inner-box">
                    <div className="big-image">
                      <img src="assets/images/resource/service-9.jpg" alt="" />
                    </div>
                    <div className='sec-title'>
                      <h3 style={{ textAlign: 'center' }}>Technical and Vocational Education and Training</h3>
						<UnderlineWithIcon/>
                    </div>
                    <div className="text">
                      <p>
                        Admas University keeps track of the needs of the general society, which shapes the academic level upgrading and opening of socially significant fields of study in the institute.
                      </p>
                      <p>
                        So far, the university has been contributing to creating BA-level qualified, capable, and ethically shaped citizens who are holding key positions in the civil service and private sectors. Nevertheless, the university understands the inherent demand of these students to upgrade their academic endeavor to the next level, for which Admas University has set a mechanism to deliver affordable, relevant, and high-quality education as its central focus.
                      </p>
                    </div>
                    <div className="facts">
                      <h3 style={{ textAlign: 'center' }}>ADMISSION CRITERIA</h3>
                      <div className="text">
                        To be eligible for admission to our university, applicants must meet the following criteria:
                      </div>
                    </div>
                    <div className="featured-blocks">
                      <div className="row">
                        <div className="featured-block col-md-10">
                          <div className="featured-inner">
                            <div className="content">
                              <div className="icon-box">
                                <span className="icon flaticon-deadline"></span>
                              </div>
                             
                              <div className="text">
                                <ol>
                                  <li>A Bachelor Degree certificate with the grade result set by the Ministry of Education of Somaliland to join University.</li>
                                  <li>Two passport size photos</li>
                                  <li>Submission of duly filled registration form</li>
                                </ol>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="sidebar-side col-xl-3 col-lg-4">
                <aside className="sidebar">
                  <div className="sidebar-widget sidebar-blog-category">
                    <ul className="blog-cat">
                      <li className="active"><a href="performance-upgrade.html">TVET Accredited Programs</a></li>
                      {programs.map((program, index) => (
                        <li key={index}>
                          <div className='program-title' onClick={() => toggleProgram(program.title)}>
                            {program.title}
                          </div>
                          {activeProgram === program.title && (
                            <ul className="program-dropdown-menu">
                              {program.campuses.map((campus, idx) => (
                                <li key={idx}>{campus}</li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="sidebar-widget contact-info-widget">
                    <div className="sidebar-title style-two">
                      <h2>Contact Us</h2>
                    </div>
                    <div className="inner-box">
                      <ul>
                        <li><span className="icon fas fa-phone"></span>0116637795</li>
                        <li><span className="icon fas fa-paper-plane"></span>https://t.me/AdmasAA</li>
                      </ul>
                    </div>
                  </div>
                </aside>
              </div>

            </div>
          </div>
        </div>
      </div>
      <ScrollToTopButton />
    </div>
  );
};

export default TVET;